/**
 * Created by Mark on 01/12/2016.
 */


import React from "react";
import { FormattedMessage } from 'react-intl';

export default class TableFooterComponent extends React.Component {

    constructor(props){
        super();

        console.log(props);
        this.state = {
            maxRowAmount : props.maxRowAmount  || 10 ,
            numberOfPages: props.numberOfPages || 0,
            pageIndex    : props.pageIndex     || 0,
            updateIndex  : props.updateIndex,
            totalRows:     props.totalRows
        }

    }

    componentWillReceiveProps(props){

        this.setState({
            maxRowAmount : props.maxRowAmount  || 10 ,
            numberOfPages: props.numberOfPages || 0,
            pageIndex    : props.pageIndex     || 0,
            updateIndex  : props.updateIndex,
            totalRows:     props.totalRows
        })
    }

    handelOnclick(goToPage , isDisabled){

        if(isDisabled) return;

        this.state.updateIndex(goToPage);
        this.setState({
            pageIndex:goToPage
        });
    }

    renderPaginationButton(goToPage , isDisabled , iconName , pageNumber , isActive ){

        var buildContent = function(iconName , pageNumber){
            if(iconName !== false) return ( <i className={"zmdi "+iconName}></i>);
            else return pageNumber
        };

        return (
            <li onClick={this.handelOnclick.bind(this , goToPage , isDisabled) } className={isDisabled ? "disabled" : isActive ? "active" : ""}>
                <a className="button">
                    { buildContent(iconName , pageNumber) }
                </a>
            </li>
        )
    };

    renderPageOptions(){
        var pages = [];



        var bottom = this.state.numberOfPages <= 3 ? 0 : this.state.pageIndex == 0 ? 0 : this.state.pageIndex - 1;
        var limit  = this.state.numberOfPages >  3 ? (bottom + 3) > this.state.numberOfPages ? this.state.numberOfPages : (bottom + 3)  : this.state.numberOfPages;


        for(var idx = bottom ; idx <= limit; idx++) pages.push(this.renderPaginationButton(idx , false , false , idx+1 , idx == Number(this.state.pageIndex)));
        return pages;
    }

    renderPagination(){

        return (
            <ul className="pagination">
                { this.renderPaginationButton(0 , this.state.pageIndex == 0 , 'zmdi-more-horiz') }
                { this.renderPaginationButton(this.state.pageIndex - 1 , this.state.pageIndex == 0 , 'zmdi-chevron-left') }
                { this.renderPageOptions() }
                { this.renderPaginationButton(this.state.pageIndex + 1 , this.state.pageIndex == this.state.numberOfPages , 'zmdi-chevron-right') }
                { this.renderPaginationButton(this.state.numberOfPages , this.state.pageIndex == this.state.numberOfPages ,'zmdi-more-horiz') }
            </ul>
        );
    }

    render(){
        return (
            <div id="data-table-command-footer" className="bootgrid-footer container-fluid">
                <div className="row">
                    <div className="col-sm-6">
                        <ul className="pagination">
                            { this.renderPagination() }
                        </ul>
                    </div>
                    <div className="col-sm-6 infoBar">
                        <div className="infos">
                            <FormattedMessage id={'ui-887'} defaultMessage="Visar {bottom} av totalt {top} grupper"  values={{bottom: String((this.state.pageIndex*this.state.maxRowAmount)+1)  , top :String(this.state.totalRows) , total:String(this.state.totalRows) }} />
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/tables/table.footer.component.js